import React, { useEffect } from "react";

const Value = () => {
  return (
    <div className="value">
      <div className="value-section">
        <div className="value-img-section">
          <img className="value-logo-one d-web-block" src="assets/img/c1.png" alt="" />
          <img className="value-logo-two" src="assets/img/c2.png" alt="" />
        </div>
        <div className="value-detail-section">
          <div className="text-uppercase value-title">Value Statement</div>
          <div className="value-dec-one">
            "We are dedicated to treating your home as our own, providing
            personalized, heartfelt service that prioritizes your needs. We
            believe in clear communication, attentive care, and building strong,
            supportive relationships within our communities. By partnering with
            HOA Board Members and tailoring our services to each community’s
            unique needs, we help create thriving neighborhoods where homeowners
            feel valued, heard, and confident in the care of their property."
          </div>
          <div className="value-subtitle">Excellence You Can See</div>
          <div className="value-dec-three">
            While it might be hard to distinguish one property management
            company from another, your community will easily recognize the
            difference that comes with choosing ABM Property Management. From
            our dedicated team to our commitment to your community, we take
            pride in making sure our clients’ needs and wants are always our
            main priority. Simply put, this means that any request sent our way,
            whether from a Board Member or individual homeowner, is always at
            the top of our “to-do” list.
          </div>
        </div>
      </div>
      <div className="mision-section">
        <div className="mision-detail">
          <div className="mision-title">our mission</div>
          <div className="mision-dec">
            Our mission at ABM Property Management is to provide exceptional
            service and a steadfast commitment to the well-being of your
            community. We distinguish ourselves through a dedicated team that
            prioritizes the needs and desires of our clients, ensuring both
            personalized care and financial stability for the Associations we
            serve. Whether responding to a Board Member or an individual
            homeowner, every request is handled with urgency and care, creating
            a thriving, well-managed community built on trust and financial
            security.
          </div>
          <div className="mision-subtitle">
            We hope that you will take some time to peruse our site and learn
            more about all that we have to offer.
          </div>
          <button className="btn btn-primary mision-btn" onClick={() => {
              window.open('https://portal.abmpropertymgmt.com/login', '_blank');
            }}>Learn More</button>
        </div>
        <div className="mision-logo">
          <img className="mision-logo-one d-web-block" src="assets/img/c3.jpg" alt="" />
          <img className="mision-logo-two" src="assets/img/c4.jpg" alt="" />
        </div>
      </div>
    </div>
  );
};
export default Value;
